import { Message } from "../../types/types";

const lineBreakTags = ["<br>", "<br/>"];

export const cleanPromoDescription = (promotion: Message) => {
  let cleanDescription = removeTitleFromDescription(promotion);
  cleanDescription = removePrecedingLineBreaks(cleanDescription);
  return cleanDescription;
};

const removeTitleFromDescription = (promotion: Message) => {
  const cleanTitle = promotion.title.trim();

  if (!promotion.description) return null;

  let cleanDescription = promotion.description?.replace(
    // nosemgrep
    `<p><strong>${cleanTitle}</strong></p>`,
    "",
  );

  cleanDescription = cleanDescription.replace(
    // nosemgrep
    `<strong>${cleanTitle}</strong>`,
    "",
  );

  // nosemgrep
  cleanDescription = cleanDescription.replace(`<p>${cleanTitle}</p>`, "");
  cleanDescription = cleanDescription.replace(`${cleanTitle}`, "");
  return cleanDescription.trim();
};

const removePrecedingLineBreaks = (description: string | null) => {
  if (!description) return null;

  lineBreakTags.map((lineBreakTag) => {
    while (description?.startsWith(lineBreakTag)) {
      description = description?.replace(lineBreakTag, "").trim();
    }
  });
  return description;
};
